export const breakpoints = {
  xs: 0,
  sm: 552,
  md: 900,
  lg: 1128,
  xl: 1360,
} as const
